/** Where "Sign In" goes, remembering where to come back to. */
export function loginUrl(next: string = window.location.pathname + window.location.search): string {
  return `/Login?next=${encodeURIComponent(next)}`;
}

/** Only same-origin paths may be used as a post-login destination. */
export function safeNext(raw: string | null | undefined, fallback = '/Events'): string {
  if (!raw) return fallback;
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/Login')) return fallback;
  return raw;
}
